<template>
   <!-- 开票申请 -->
   <div class="issue-record">
    <ab-list-query>
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="委托方" v-model.trim="formSearch.principalName" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="型号" v-model.trim="formSearch.model" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input  placeholder="品牌" v-model.trim="formSearch.brand" clearable></el-input>
                </el-col>
                <el-col :span="4">
                    <ab-timeSearch
                        class="searchBox"
                        startSrc="操作时间起"
                        endSrc="操作时间止"
                        v-model="formSearch.updateTimeArr1"
                        @searchEvent="changeTimeRange"
                    ></ab-timeSearch>
                </el-col>
                <el-col :span="4">
                    <ab-select
                        url="/p/user/list"
                        placeholder="操作人"
                        inputKey="realName"
                        descKey="realName"
                        v-model="formSearch.createByName"
                        :urlData="{isEnabled: 1 , pageSize: 10, pageNum: 1}"
                        @handleSelect="itemItemUnitName">
                    </ab-select>
                </el-col>
                <el-col :span="4" class="text-left">
                    <el-button @click="searchForm">搜索</el-button>
                    <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
            <el-button @click="exportFile" :loading="load.exportLoading">导出</el-button>
        </template>

        <template #table>
            <ab-table
                class="materialTable"
                ref="table"
                stripe
                indexWidth="50"
                showOrder
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="load.isLoading"
                @filterColumns="filterColumns"
            >
                <template #content='scope'>
                    <span v-if="scope.row.signedUrl">确认《授权协议》, <u style="color: #0a7cff; cursor: pointer;" @click="open(scope.row.signedUrl)">查看协议内容</u> </span>
                    <span v-else>{{scope.row.content}}</span>
                </template>
            </ab-table>
            
        </template>

        <template #page>
            <ab-page
                :pageTotal="page.total" 
                :currentPage='page.currentPage' 
                :pageSize="page.pageSize" 
                :pageSizes="page.pageSizes"
                @searchForm="pageSearch"
            ></ab-page>
        </template>
    </ab-list-query>
    <ab-preview :preview="preview"></ab-preview>
   </div>
</template>

<script>
export default {
    name: 'issue-operate',
    data() {
        return {
            load:{
                isLoading: false,
                exportLoading: false
            },
            preview: {
                show: false
            },
            formSearch: {},
            columns: [
                {
                    props: 'createTime',
                    labels: '操作时间',
                    widths: 120,
                },
                {
                    props: 'principalName',
                    labels: '委托方',
                    widths: 80
                },
                {
                    props: 'content',
                    labels: '操作内容',
                    widths: 120,
                    slot: 'slot'
                },
                {
                    props: 'createByName',
                    labels: '操作人',
                    widths: 80
                }
            ],
            tableData: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            }
        }
    },
    methods:{
        //联系人
        itemItemUnitName(val){
            this.formSearch.createById = val.id
        },
        //查看协议
        open(url) {
            this.preview.fileUrl = url
            this.preview.show = true
        },
        //委托方
        itemCodeSelect(item){
            this.formSeach.principalId = item ? item.id : ''
        },
        //日期
        changeTimeRange(obj){
            this.formSearch.updateTimeArr1=obj
            if (obj) {
                this.formSearch.createTimeStart = obj[0];
                this.formSearch.createTimeEnd = obj[1];
            } else {
                this.formSearch.createTimeStart = "";
                this.formSearch.createTimeEnd = "";
            }
        },
        filterColumns(val){
            this.columns=val
        },
        pageSearch(val){
            this.page.pageSize=val.pageSize
            this.page.currentPage=val.currentPage
            this.getListData()
        },
        //获取数据
        getListData(){
            this.load.isLoading=true
            let dataList = {
                data: this.formSearch,
                pageNum: this.page.currentPage, 
                pageSize: this.page.pageSize
            }
            this.$post("/cms/taoicOper/list",dataList).then(({ data }) => {
                if (data && data.code === "C0000") {
                    this.tableData = data.result .list;
                    this.page.total = data.result.total;
                } else {
                    this.tableData = [];
                    this.page.total = 0;
                }
            }).finally(() => {
                this.load.isLoading=false
            });
        },
        //搜索
        searchForm(){
            this.getListData()
        },
        //列表选择项
        handleSelectionChange(array) {
            this.multipleSelection = array;
        },
        //导出
        exportFile() {
            this.load.exportLoading=true
            let params = {}
            let excelField = this.columns.map(e => e.props);
            params.excelField= excelField 
            params.data = this.formSearch,
            this.$post("/cms/taoicOper/export", params).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.target = "_blank";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.load.exportLoading=false
            });
        },
    },
    created(){
        this.getListData()
    },
    mounted(){}
}
</script>

<style lang="scss">
.issue-record{
    .el-menu.el-menu--horizontal{
        display: none;
    }
}
</style>